import React from 'react';
import PropTypes from 'prop-types';

const IconInStock = ({
  width = 20,
  height = 15,
  color = 'black',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_3_2147)">
      <path
        d="M14.191 15L7.96631 10.513V4.01401L14.191 8.50103V15.0001V15ZM8.38209 10.2904L13.7753 14.1779V8.72356L8.38209 4.83599V10.2904Z"
        fill={color}
      />
      <path
        d="M13.7751 15V8.50094L19.9999 4.01392V10.513L13.7751 15ZM14.1909 8.72355V14.1779L19.5841 10.2904V4.83598L14.1909 8.72355Z"
        fill={color}
      />
      <path
        d="M16.7553 2.03793L10.946 6.2247L11.1846 6.57508L16.9939 2.38831L16.7553 2.03793Z"
        fill={color}
      />
      <path
        d="M14.1038 0.000812526L13.8652 0.351151L19.6738 4.53896L19.9124 4.18863L14.1038 0.000812526Z"
        fill={color}
      />
      <path
        d="M13.8645 0.00108047L8.05518 4.18785L8.29372 4.53823L14.103 0.351461L13.8645 0.00108047Z"
        fill={color}
      />
      <path d="M6.81768 9.29306H0V9.72085H6.81768V9.29306Z" fill={color} />
      <path d="M6.81757 8.04051H1.70435V8.4683H6.81757V8.04051Z" fill={color} />
      <path
        d="M6.81756 6.78789H3.63794V7.21568H6.81756V6.78789Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_3_2147">
        <rect width="20" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

IconInStock.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export default IconInStock;
